import React, { useState } from "react";
import * as PropTypes from "prop-types";
import { databasePropType } from "../../../propTypes";
import { defaultAreaId } from "../../../constants";
import AreaChooser from "../../choosers/AreaChooser";
import DataViewerFrame from "../../widgets/DataViewerFrame";
import ProjectedFundingGapsWithinPublicSectorTable from "./ProjectedFundingGapsWithinPublicSectorTable";

const ProjectedFundingGapsWithinPublicSectorTableWidget = props => {
  const [areaId, setAreaId] = useState(defaultAreaId);

  return (
    <DataViewerFrame
      reference="Table 1.3"
      title="Projected Funding Gaps Within Public Sector, 2020 and 2025"
      subtitle="Within Private Sector"
      filters={[
        <AreaChooser
          id="table-1-3"
          areas={props.database.areas}
          selectedKey={areaId}
          onChange={areaId => {
            setAreaId(areaId);

            props.onChange({
              widget:
                "theme1.projectedFundingGapsWithinPublicSectorTableWidget",
              payload: {
                areaId
              }
            });
          }}
        />
      ]}
      onDownloadCsv={() => {
        props.onDownloadCsv({
          area: props.database.areas[areaId].area
        });
      }}
    >
      <ProjectedFundingGapsWithinPublicSectorTable
        data={props.data}
        areaId={areaId}
      />
    </DataViewerFrame>
  );
};

ProjectedFundingGapsWithinPublicSectorTableWidget.propTypes = {
  database: databasePropType,
  data: PropTypes.array.isRequired,
  onDownloadCsv: PropTypes.func.isRequired
};

export default ProjectedFundingGapsWithinPublicSectorTableWidget;
